export default {
  methods: {
    formato_numero (value, decimales) {
      if (value == null || value === 0) {
        value = 0;
        return value;
      } else {
        let val = (value / 1).toFixed(decimales).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
    },
    getBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    getImgFromBase64 (url) {
      let fileName = url.substring(url.lastIndexOf('/') + 1);
      return new Promise((resolve, reject) => {
        fetch(url)
          .then(res => res.blob())
          .then(blob => {
            // Revisar type y nombre de fichero (Guardar en la API al insertar?)
            const file = new File([blob], fileName, { type: blob.type });
            resolve(file);
          });
      });
    }
  }
};
